import pick from 'lodash/pick';
import pickBy from 'lodash/pickBy';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import config from '../../config';
import { types as sdkTypes } from '../../util/sdkLoader';
import { isTransactionsTransitionInvalidTransition, storableError } from '../../util/errors';
import {
  txIsEnquired,
  txIsNeedToReschedule,
  getReview1Transition,
  getReview2Transition,
  txIsInFirstReviewBy,
  TRANSITION_ACCEPT,
  TRANSITION_RESCHEDULE,
  TRANSITION_DECLINE,
  TRANSITION_TRANSFERRED,
  TRANSITION_REQUEST_EXTEND_BOOKING,
  TRANSITION_REQUEST_OFFER,
  TRANSITION_RE_OFFER,
  isPrivileged,
  TRANSITION_SAVE_EXTEND_BOOKING,
  TRANSITION_ACCEPT_EXTEND_BOOKING,
} from '../../util/customTransaction/mainRentalTransaction';
import {
  transactionLineItems,
  extendTransactionLineItems,
  reofferTransactionLineItems,
  apiRetryPayment,
  apiRenewBond,
  transitionPrivileged,
  actionPrivileged,
  addAvailabilityExceptionCurrentBooking,
  removeAvailabilityExceptionCurrentBooking,
  saveLastMessageAt,
  createHoldingSlotTransaction,
  extendTransitionPrivileged,
  declineHoldingSlotTransaction,
} from '../../util/api';
import * as log from '../../util/log';
import {
  updatedEntities,
  denormalisedEntities,
  denormalisedResponseEntities,
} from '../../util/data';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { fetchCurrentUserNotifications } from '../../ducks/user.duck';
import { txLastTransition } from '../../util/transaction';
import {
  TRANSITION_EXTEND_REQUEST_EXTEND_BOOKING,
  TRANSITION_EXTEND_REQUEST_PAYMENT_FREE,
  TRANSITION_EXTEND_PAYOUT_ADDITION_FEE,
  TRANSITION_EXTEND_REQUEST_PAYMENT,
  TRANSITION_EXTEND_RESCHEDULE,
  TRANSITION_EXTEND_FREE_RESCHEDULE,
  isPrivileged as isExtendPrivileged,
} from '../../util/customTransaction/extendRentalTransaction';
import {
  ACTION_ADD_AVAILABILITY_EXCEPTIONS,
  ACTION_REMOVE_AVAILABILITY_EXCEPTIONS,
} from '../../util/types';
import uniqBy from 'lodash/uniqBy';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import { daysBetween } from '../../util/dates';

const { UUID } = sdkTypes;

const MESSAGES_PAGE_SIZE = 100;
const CUSTOMER = 'customer';

// ================ Action types ================ //

export const SET_INITIAL_VALUES = 'app/TransactionPage/SET_INITIAL_VALUES';

export const FETCH_TRANSACTION_REQUEST = 'app/TransactionPage/FETCH_TRANSACTION_REQUEST';
export const FETCH_TRANSACTION_SUCCESS = 'app/TransactionPage/FETCH_TRANSACTION_SUCCESS';
export const FETCH_TRANSACTION_ERROR = 'app/TransactionPage/FETCH_TRANSACTION_ERROR';

export const FETCH_TRANSITIONS_REQUEST = 'app/TransactionPage/FETCH_TRANSITIONS_REQUEST';
export const FETCH_TRANSITIONS_SUCCESS = 'app/TransactionPage/FETCH_TRANSITIONS_SUCCESS';
export const FETCH_TRANSITIONS_ERROR = 'app/TransactionPage/FETCH_TRANSITIONS_ERROR';

export const RESCHEDULE_SALE_REQUEST = 'app/TransactionPage/RESCHEDULE_SALE_REQUEST';
export const RESCHEDULE_SALE_SUCCESS = 'app/TransactionPage/RESCHEDULE_SALE_SUCCESS';
export const RESCHEDULE_SALE_ERROR = 'app/TransactionPage/RESCHEDULE_SALE_ERROR';

export const ACCEPT_SALE_REQUEST = 'app/TransactionPage/ACCEPT_SALE_REQUEST';
export const ACCEPT_SALE_SUCCESS = 'app/TransactionPage/ACCEPT_SALE_SUCCESS';
export const ACCEPT_SALE_ERROR = 'app/TransactionPage/ACCEPT_SALE_ERROR';

export const DECLINE_SALE_REQUEST = 'app/TransactionPage/DECLINE_SALE_REQUEST';
export const DECLINE_SALE_SUCCESS = 'app/TransactionPage/DECLINE_SALE_SUCCESS';
export const DECLINE_SALE_ERROR = 'app/TransactionPage/DECLINE_SALE_ERROR';

export const FETCH_MESSAGES_REQUEST = 'app/TransactionPage/FETCH_MESSAGES_REQUEST';
export const FETCH_MESSAGES_SUCCESS = 'app/TransactionPage/FETCH_MESSAGES_SUCCESS';
export const FETCH_MESSAGES_ERROR = 'app/TransactionPage/FETCH_MESSAGES_ERROR';

export const SEND_MESSAGE_REQUEST = 'app/TransactionPage/SEND_MESSAGE_REQUEST';
export const SEND_MESSAGE_SUCCESS = 'app/TransactionPage/SEND_MESSAGE_SUCCESS';
export const SEND_MESSAGE_ERROR = 'app/TransactionPage/SEND_MESSAGE_ERROR';

export const SEND_REVIEW_REQUEST = 'app/TransactionPage/SEND_REVIEW_REQUEST';
export const SEND_REVIEW_SUCCESS = 'app/TransactionPage/SEND_REVIEW_SUCCESS';
export const SEND_REVIEW_ERROR = 'app/TransactionPage/SEND_REVIEW_ERROR';

export const FETCH_TIME_SLOTS_REQUEST = 'app/TransactionPage/FETCH_TIME_SLOTS_REQUEST';
export const FETCH_TIME_SLOTS_SUCCESS = 'app/TransactionPage/FETCH_TIME_SLOTS_SUCCESS';
export const FETCH_TIME_SLOTS_ERROR = 'app/TransactionPage/FETCH_TIME_SLOTS_ERROR';

export const FETCH_LINE_ITEMS_REQUEST = 'app/TransactionPage/FETCH_LINE_ITEMS_REQUEST';
export const FETCH_LINE_ITEMS_SUCCESS = 'app/TransactionPage/FETCH_LINE_ITEMS_SUCCESS';
export const FETCH_LINE_ITEMS_ERROR = 'app/TransactionPage/FETCH_LINE_ITEMS_ERROR';

export const TRANSIT_REQUEST = 'app/TransactionPage/TRANSIT_REQUEST';
export const TRANSIT_SUCCESS = 'app/TransactionPage/TRANSIT_SUCCESS';
export const TRANSIT_ERROR = 'app/TransactionPage/TRANSIT_ERROR';

export const FETCH_EXTEND_TRANSACTION_SUCCESS =
  'app/TransactionPage/FETCH_EXTEND_TRANSACTION_SUCCESS';

export const RETRY_PAYMENT_REQUEST = 'app/TransactionPage/RETRY_PAYMENT_REQUEST';
export const RETRY_PAYMENT_SUCCESS = 'app/TransactionPage/RETRY_PAYMENT_SUCCESS';
export const RETRY_PAYMENT_ERROR = 'app/TransactionPage/RETRY_PAYMENT_ERROR';

export const RENEW_BOND_REQUEST = 'app/TransactionPage/RENEW_BOND_REQUEST';
export const RENEW_BOND_SUCCESS = 'app/TransactionPage/RENEW_BOND_SUCCESS';
export const RENEW_BOND_ERROR = 'app/TransactionPage/RENEW_BOND_ERROR';

export const ADD_AVAILABILITY_EXCEPTION_SUCCESS =
  'app/TransactionPage/ADD_AVAILABILITY_EXCEPTION_SUCCESS';
export const REMOVE_AVAILABILITY_EXCEPTION_SUCCESS =
  'app/TransactionPage/REMOVE_AVAILABILITY_EXCEPTION_SUCCESS';

export const CREATE_HOLDING_SLOT_TX_REQUEST = 'app/TransactionPage/CREATE_HOLDING_SLOT_TX_REQUEST';
export const CREATE_HOLDING_SLOT_TX_SUCCESS = 'app/TransactionPage/CREATE_HOLDING_SLOT_TX_SUCCESS';
export const CREATE_HOLDING_SLOT_TX_ERROR = 'app/TransactionPage/CREATE_HOLDING_SLOT_TX_ERROR';

export const DECLINE_HOLDING_SLOT_TX_REQUEST = 'app/TransactionPage/DECLINE_HOLDING_SLOT_TX_REQUEST';
export const DECLINE_HOLDING_SLOT_TX_SUCCESS = 'app/TransactionPage/DECLINE_HOLDING_SLOT_TX_SUCCESS';
export const DECLINE_HOLDING_SLOT_TX_ERROR = 'app/TransactionPage/DECLINE_HOLDING_SLOT_TX_ERROR';

export const WAIT_AUTO_TRANSITION_START_REVIEW_REQUEST =
  'app/TransactionPage/WAIT_AUTO_TRANSITION_START_REVIEW_REQUEST';
export const WAIT_AUTO_TRANSITION_START_REVIEW_SUCCESS =
  'app/TransactionPage/WAIT_AUTO_TRANSITION_START_REVIEW_SUCCESS';
export const WAIT_AUTO_TRANSITION_START_REVIEW_ERROR =
  'app/TransactionPage/WAIT_AUTO_TRANSITION_START_REVIEW_ERROR';

// ================ Reducer ================ //

const initialState = {
  fetchTransactionInProgress: false,
  fetchTransactionError: null,
  transactionRef: null,
  rescheduleInProgress: false,
  rescheduleSaleError: null,
  acceptInProgress: false,
  acceptSaleError: null,
  declineInProgress: false,
  declineSaleError: null,
  fetchMessagesInProgress: false,
  fetchMessagesError: null,
  totalMessages: 0,
  totalMessagePages: 0,
  oldestMessagePageFetched: 0,
  messages: [],
  initialMessageFailedToTransaction: null,
  savePaymentMethodFailed: false,
  sendMessageInProgress: false,
  sendMessageError: null,
  sendReviewInProgress: false,
  sendReviewError: null,
  timeSlots: null,
  fetchTimeSlotsError: null,
  fetchTransitionsInProgress: false,
  fetchTransitionsError: null,
  processTransitions: null,
  lineItems: null,
  fetchLineItemsInProgress: false,
  fetchLineItemsError: null,
  transitInProgress: false,
  transitError: null,
  extendTransactionRef: [],
  retryPaymentInProgress: false,
  retryPaymentError: null,
  renewBondInProgress: false,
  renewBondError: null,
  listingId: null,
  exceptionId: null,
  createHoldingSlotTxInProgress: false,
  createHoldingSlotTxError: null,
  declineHoldingSlotTxInProgress: false,
  declineHoldingSlotTxError: null,
  waitAutoTransitionStartReviewInProgress: false,
  waitAutoTransitionStartReviewError: null,
};

// Merge entity arrays using ids, so that conflicting items in newer array (b) overwrite old values (a).
// const a = [{ id: { uuid: 1 } }, { id: { uuid: 3 } }];
// const b = [{ id: : { uuid: 2 } }, { id: : { uuid: 1 } }];
// mergeEntityArrays(a, b)
// => [{ id: { uuid: 3 } }, { id: : { uuid: 2 } }, { id: : { uuid: 1 } }]
const mergeEntityArrays = (a, b) => {
  return a.filter(aEntity => !b.find(bEntity => aEntity.id.uuid === bEntity.id.uuid)).concat(b);
};

export default function checkoutPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SET_INITIAL_VALUES:
      return { ...initialState, ...payload };

    case FETCH_TRANSACTION_REQUEST:
      return {
        ...state,
        fetchTransactionInProgress: true,
        fetchTransactionError: null,
        extendTransactionRef: [],
      };
    case FETCH_TRANSACTION_SUCCESS: {
      const transactionRef = { id: payload.data.data.id, type: 'transaction' };
      const listingId = get(payload, 'data.data.relationships.listing.data.id.uuid', null);
      return { ...state, fetchTransactionInProgress: false, transactionRef, listingId };
    }
    case FETCH_TRANSACTION_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, fetchTransactionInProgress: false, fetchTransactionError: payload };

    case FETCH_TRANSITIONS_REQUEST:
      return { ...state, fetchTransitionsInProgress: true, fetchTransitionsError: null };
    case FETCH_TRANSITIONS_SUCCESS:
      return { ...state, fetchTransitionsInProgress: false, processTransitions: payload };
    case FETCH_TRANSITIONS_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, fetchTransitionsInProgress: false, fetchTransitionsError: payload };

    case RESCHEDULE_SALE_REQUEST:
      return {
        ...state,
        rescheduleInProgress: true,
        rescheduleSaleError: null,
        acceptSaleError: null,
        declineSaleError: null,
      };
    case RESCHEDULE_SALE_SUCCESS:
      return { ...state, rescheduleInProgress: false };
    case RESCHEDULE_SALE_ERROR:
      return { ...state, rescheduleInProgress: false, rescheduleSaleError: payload };

    case ACCEPT_SALE_REQUEST:
      return {
        ...state,
        acceptInProgress: true,
        acceptSaleError: null,
        rescheduleSaleError: null,
        declineSaleError: null,
      };
    case ACCEPT_SALE_SUCCESS:
      return { ...state, acceptInProgress: false };
    case ACCEPT_SALE_ERROR:
      return { ...state, acceptInProgress: false, acceptSaleError: payload };

    case DECLINE_SALE_REQUEST:
      return {
        ...state,
        declineInProgress: true,
        declineSaleError: null,
        rescheduleSaleError: null,
        acceptSaleError: null,
      };
    case DECLINE_SALE_SUCCESS:
      return { ...state, declineInProgress: false };
    case DECLINE_SALE_ERROR:
      return { ...state, declineInProgress: false, declineSaleError: payload };

    case FETCH_MESSAGES_REQUEST:
      return { ...state, fetchMessagesInProgress: true, fetchMessagesError: null };
    case FETCH_MESSAGES_SUCCESS: {
      const oldestMessagePageFetched =
        state.oldestMessagePageFetched > payload.page
          ? state.oldestMessagePageFetched
          : payload.page;
      return {
        ...state,
        fetchMessagesInProgress: false,
        messages: mergeEntityArrays(state.messages, payload.messages),
        totalMessages: payload.totalItems,
        totalMessagePages: payload.totalPages,
        oldestMessagePageFetched,
      };
    }
    case FETCH_MESSAGES_ERROR:
      return { ...state, fetchMessagesInProgress: false, fetchMessagesError: payload };

    case SEND_MESSAGE_REQUEST:
      return {
        ...state,
        sendMessageInProgress: true,
        sendMessageError: null,
        initialMessageFailedToTransaction: null,
      };
    case SEND_MESSAGE_SUCCESS:
      return { ...state, sendMessageInProgress: false };
    case SEND_MESSAGE_ERROR:
      return { ...state, sendMessageInProgress: false, sendMessageError: payload };

    case SEND_REVIEW_REQUEST:
      return { ...state, sendReviewInProgress: true, sendReviewError: null };
    case SEND_REVIEW_SUCCESS:
      return { ...state, sendReviewInProgress: false };
    case SEND_REVIEW_ERROR:
      return { ...state, sendReviewInProgress: false, sendReviewError: payload };

    case FETCH_TIME_SLOTS_REQUEST:
      return { ...state, fetchTimeSlotsError: null };
    case FETCH_TIME_SLOTS_SUCCESS:
      return { ...state, timeSlots: payload };
    case FETCH_TIME_SLOTS_ERROR:
      return { ...state, fetchTimeSlotsError: payload };

    case FETCH_LINE_ITEMS_REQUEST:
      return {
        ...state,
        lineItems: null,
        fetchLineItemsInProgress: true,
        fetchLineItemsError: null,
      };
    case FETCH_LINE_ITEMS_SUCCESS:
      return { ...state, fetchLineItemsInProgress: false, lineItems: payload };
    case FETCH_LINE_ITEMS_ERROR:
      return { ...state, fetchLineItemsInProgress: false, fetchLineItemsError: payload };
    case TRANSIT_REQUEST:
      return { ...state, transitInProgress: true };
    case TRANSIT_SUCCESS:
      return { ...state, transitInProgress: false };
    case TRANSIT_ERROR:
      return { ...state, transitInProgress: false, transitError: payload };
    case FETCH_EXTEND_TRANSACTION_SUCCESS:
      const extendTransactionRef = state.extendTransactionRef;
      const newTransactionRef = { id: payload.id, type: 'transaction' };
      extendTransactionRef.push(newTransactionRef);
      return {
        ...state,
        extendTransactionRef: uniqBy(extendTransactionRef, 'id.uuid'),
      };
    case RETRY_PAYMENT_REQUEST:
      return {
        ...state,
        retryPaymentInProgress: true,
        retryPaymentError: null,
      };
    case RETRY_PAYMENT_SUCCESS:
      return {
        ...state,
        retryPaymentInProgress: false,
      };
    case RETRY_PAYMENT_ERROR:
      return {
        ...state,
        retryPaymentInProgress: false,
        retryPaymentError: payload,
      };
    case RENEW_BOND_REQUEST:
      return {
        ...state,
        renewBondInProgress: true,
        renewBondError: null,
      };
    case RENEW_BOND_SUCCESS:
      return {
        ...state,
        renewBondInProgress: false,
      };
    case RENEW_BOND_ERROR:
      return {
        ...state,
        renewBondInProgress: false,
        renewBondError: payload,
      };

    case ADD_AVAILABILITY_EXCEPTION_SUCCESS:
      return {
        ...state,
        exceptionId: payload,
      };
    case REMOVE_AVAILABILITY_EXCEPTION_SUCCESS:
      return {
        ...state,
        exceptionId: null,
      };

    case CREATE_HOLDING_SLOT_TX_REQUEST:
      return {
        ...state,
        createHoldingSlotTxInProgress: true,
        createHoldingSlotTxError: null,
      };
    case CREATE_HOLDING_SLOT_TX_SUCCESS:
      return {
        ...state,
        createHoldingSlotTxInProgress: false,
      };
    case CREATE_HOLDING_SLOT_TX_ERROR:
      return {
        ...state,
        createHoldingSlotTxInProgress: false,
        createHoldingSlotTxError: payload,
      };

    case DECLINE_HOLDING_SLOT_TX_REQUEST:
      return {
        ...state,
        declineHoldingSlotTxInProgress: true,
        declineHoldingSlotTxError: null,
      };
    case DECLINE_HOLDING_SLOT_TX_SUCCESS:
      return {
        ...state,
        declineHoldingSlotTxInProgress: false,
      };
    case DECLINE_HOLDING_SLOT_TX_ERROR:
      return {
        ...state,
        declineHoldingSlotTxInProgress: false,
        declineHoldingSlotTxError: payload,
      }

    case WAIT_AUTO_TRANSITION_START_REVIEW_REQUEST:
      return {
        ...state,
        waitAutoTransitionStartReviewInProgress: true,
        waitAutoTransitionStartReviewError: null,
      };
    case WAIT_AUTO_TRANSITION_START_REVIEW_SUCCESS:
      return {
        ...state,
        waitAutoTransitionStartReviewInProgress: false,
      };
    case WAIT_AUTO_TRANSITION_START_REVIEW_ERROR:
      return {
        ...state,
        waitAutoTransitionStartReviewInProgress: false,
        waitAutoTransitionStartReviewError: payload,
      };

    default:
      return state;
  }
}

// ================ Selectors ================ //

export const someActionInProgress = state => {
  return (
    state.TransactionPage.acceptInProgress ||
    state.TransactionPage.declineInProgress ||
    state.TransactionPage.rescheduleInProgress
  );
};

export const transitInProgress = state => {
  return (
    state.TransactionPage.acceptInProgress ||
    state.TransactionPage.declineInProgress ||
    state.TransactionPage.rescheduleInProgress ||
    state.TransactionPage.transitInProgress
  );
};

// ================ Action creators ================ //
export const setInitialValues = initialValues => ({
  type: SET_INITIAL_VALUES,
  payload: pick(initialValues, Object.keys(initialState)),
});

const fetchTransactionRequest = () => ({ type: FETCH_TRANSACTION_REQUEST });
const fetchTransactionSuccess = response => ({
  type: FETCH_TRANSACTION_SUCCESS,
  payload: response,
});
const fetchTransactionError = e => ({ type: FETCH_TRANSACTION_ERROR, error: true, payload: e });

const fetchTransitionsRequest = () => ({ type: FETCH_TRANSITIONS_REQUEST });
const fetchTransitionsSuccess = response => ({
  type: FETCH_TRANSITIONS_SUCCESS,
  payload: response,
});
const fetchTransitionsError = e => ({ type: FETCH_TRANSITIONS_ERROR, error: true, payload: e });

const rescheduleSaleRequest = () => ({ type: RESCHEDULE_SALE_REQUEST });
const rescheduleSaleSuccess = () => ({ type: RESCHEDULE_SALE_SUCCESS });
const rescheduleSaleError = e => ({ type: RESCHEDULE_SALE_ERROR, error: true, payload: e });

const acceptSaleRequest = () => ({ type: ACCEPT_SALE_REQUEST });
const acceptSaleSuccess = () => ({ type: ACCEPT_SALE_SUCCESS });
const acceptSaleError = e => ({ type: ACCEPT_SALE_ERROR, error: true, payload: e });

const declineSaleRequest = () => ({ type: DECLINE_SALE_REQUEST });
const declineSaleSuccess = () => ({ type: DECLINE_SALE_SUCCESS });
const declineSaleError = e => ({ type: DECLINE_SALE_ERROR, error: true, payload: e });

const fetchMessagesRequest = () => ({ type: FETCH_MESSAGES_REQUEST });
const fetchMessagesSuccess = (messages, pagination) => ({
  type: FETCH_MESSAGES_SUCCESS,
  payload: { messages, ...pagination },
});
const fetchMessagesError = e => ({ type: FETCH_MESSAGES_ERROR, error: true, payload: e });

const sendMessageRequest = () => ({ type: SEND_MESSAGE_REQUEST });
const sendMessageSuccess = () => ({ type: SEND_MESSAGE_SUCCESS });
const sendMessageError = e => ({ type: SEND_MESSAGE_ERROR, error: true, payload: e });

const sendReviewRequest = () => ({ type: SEND_REVIEW_REQUEST });
const sendReviewSuccess = () => ({ type: SEND_REVIEW_SUCCESS });
const sendReviewError = e => ({ type: SEND_REVIEW_ERROR, error: true, payload: e });

const fetchTimeSlotsRequest = () => ({ type: FETCH_TIME_SLOTS_REQUEST });
const fetchTimeSlotsSuccess = timeSlots => ({
  type: FETCH_TIME_SLOTS_SUCCESS,
  payload: timeSlots,
});
const fetchTimeSlotsError = e => ({
  type: FETCH_TIME_SLOTS_ERROR,
  error: true,
  payload: e,
});

export const fetchLineItemsRequest = () => ({ type: FETCH_LINE_ITEMS_REQUEST });
export const fetchLineItemsSuccess = lineItems => ({
  type: FETCH_LINE_ITEMS_SUCCESS,
  payload: lineItems,
});
export const fetchLineItemsError = error => ({
  type: FETCH_LINE_ITEMS_ERROR,
  error: true,
  payload: error,
});

const transitRequest = () => ({ type: TRANSIT_REQUEST });
const transitSuccess = () => ({
  type: TRANSIT_SUCCESS,
});
const transitError = e => ({
  type: TRANSIT_ERROR,
  error: true,
  payload: e,
});

export const fetchExtendTransactionSuccess = payload => ({
  type: FETCH_EXTEND_TRANSACTION_SUCCESS,
  payload,
});

const retryPaymentRequest = () => ({ type: RETRY_PAYMENT_REQUEST });
const retryPaymentSuccess = () => ({
  type: RETRY_PAYMENT_SUCCESS,
});
const retryPaymentError = e => ({
  type: RETRY_PAYMENT_ERROR,
  error: true,
  payload: e,
});

const renewBondRequest = () => ({ type: RENEW_BOND_REQUEST });
const renewBondSuccess = () => ({
  type: RENEW_BOND_SUCCESS,
});
const renewBondError = e => ({
  type: RENEW_BOND_ERROR,
  error: true,
  payload: e,
});

const addAvailabilityExceptionSuccess = exceptionId => ({
  type: ADD_AVAILABILITY_EXCEPTION_SUCCESS,
  payload: exceptionId,
});
const removeAvailabilityExceptionSuccess = () => ({
  type: REMOVE_AVAILABILITY_EXCEPTION_SUCCESS,
});

const createHoldingSlotTxRequest = () => ({ type: CREATE_HOLDING_SLOT_TX_REQUEST });
const createHoldingSlotTxSuccess = () => ({
  type: CREATE_HOLDING_SLOT_TX_SUCCESS,
});
const createHoldingSlotTxFail = e => ({
  type: CREATE_HOLDING_SLOT_TX_ERROR,
  error: true,
  payload: e,
});

const declineHoldingSlotTxRequest = () => ({ type: DECLINE_HOLDING_SLOT_TX_REQUEST });
const declineHoldingSlotTxSuccess = () => ({
  type: DECLINE_HOLDING_SLOT_TX_SUCCESS,
});
const declineHoldingSlotTxFail = e => ({
  type: DECLINE_HOLDING_SLOT_TX_ERROR,
});
const waitAutoTransitionStartReviewRequest = () => ({
  type: WAIT_AUTO_TRANSITION_START_REVIEW_REQUEST,
});
const waitAutoTransitionStartReviewSuccess = () => ({
  type: WAIT_AUTO_TRANSITION_START_REVIEW_SUCCESS,
});
const waitAutoTransitionStartReviewError = e => ({
  type: WAIT_AUTO_TRANSITION_START_REVIEW_ERROR,
  error: true,
  payload: e,
});

// ================ Thunks ================ //

const listingRelationship = txResponse => {
  return txResponse.data.data.relationships.listing.data;
};

export const fetchTransaction = (id, txRole) => (dispatch, getState, sdk) => {
  dispatch(fetchTransactionRequest());
  let txResponse = null;
  const ensuredTxId = typeof id === 'string' ? new UUID(id) : id;
  return sdk.transactions
    .show(
      {
        id: ensuredTxId,
        include: [
          'customer',
          'customer.profileImage',
          'provider',
          'provider.profileImage',
          'listing',
          'booking',
          'reviews',
          'reviews.author',
          'reviews.subject',
        ],
        ...IMAGE_VARIANTS,
      },
      { expand: true }
    )
    .then(response => {
      txResponse = response;
      const listingId = listingRelationship(response).id;
      const entities = updatedEntities({}, response.data);
      const listingRef = { id: listingId, type: 'listing' };
      const transactionRef = { id: ensuredTxId, type: 'transaction' };
      const denormalised = denormalisedEntities(entities, [listingRef, transactionRef]);
      const listing = denormalised[0];
      const transaction = denormalised[1];

      const lastTransition = txLastTransition(transaction);
      // Fetch time slots for transactions that are in enquired state
      const canFetchTimeslots =
        (config.enableAvailability &&
          transaction &&
          (txIsEnquired(transaction) ||
            txIsNeedToReschedule(transaction) ||
            lastTransition === TRANSITION_REQUEST_OFFER ||
            lastTransition === TRANSITION_RE_OFFER)) ||
        (txRole === 'provider' && lastTransition === TRANSITION_REQUEST_EXTEND_BOOKING) ||
        lastTransition === TRANSITION_TRANSFERRED;

      if (canFetchTimeslots) {
        dispatch(fetchTimeSlots(listingId));
      }

      const canFetchListing = listing && listing.attributes && !listing.attributes.deleted;
      if (canFetchListing) {
        return sdk.listings.show({
          id: listingId,
          include: ['author', 'author.profileImage', 'images'],
          ...IMAGE_VARIANTS,
        });
      } else {
        return response;
      }
    })
    .then(response => {
      dispatch(addMarketplaceEntities(txResponse));
      dispatch(addMarketplaceEntities(response));
      const { extendTransactionId } = txResponse.data.data.attributes.protectedData;
      if (extendTransactionId) {
        return dispatch(fetchExtendTransaction(new UUID(extendTransactionId), txRole)).then(
          () => response
        );
      }
      return response;
    })
    .then(response => {
      dispatch(fetchTransactionSuccess(txResponse));
      return txResponse;
    })
    .catch(e => {
      dispatch(fetchTransactionError(storableError(e)));
      throw e;
    });
};

export const fetchExtendTransaction = (txId, txRole) => (dispatch, getState, sdk) => {
  return sdk.transactions
    .show(
      {
        id: txId,
        include: ['listing', 'booking'],
      },
      { expand: true }
    )
    .then(response => {
      const listingId = listingRelationship(response).id;
      const listingRef = { id: listingId, type: 'listing' };
      const transactionRef = { id: txId, type: 'transaction' };
      const entities = updatedEntities({}, response.data);
      const denormalised = denormalisedEntities(entities, [listingRef, transactionRef]);
      const transaction = denormalised[1];
      const { extendTransactionId } = transaction.attributes.protectedData;
      const lastTransition = txLastTransition(transaction);

      dispatch(addMarketplaceEntities(response));
      dispatch(fetchExtendTransactionSuccess(transaction));

      const canFetchTimeslots =
        (txRole === 'provider' && lastTransition === TRANSITION_EXTEND_REQUEST_EXTEND_BOOKING) ||
        lastTransition === TRANSITION_EXTEND_REQUEST_PAYMENT_FREE ||
        lastTransition === TRANSITION_EXTEND_PAYOUT_ADDITION_FEE;

      if (canFetchTimeslots) {
        dispatch(fetchTimeSlots(listingId));
      }

      if (extendTransactionId) {
        return dispatch(fetchExtendTransaction(new UUID(extendTransactionId), txRole));
      }
      return response;
    })
    .catch(e => {
      dispatch(fetchTransactionError(storableError(e)));
      throw e;
    });
};

export const rescheduleSale = (id, params) => (dispatch, getState, sdk) => {
  if (someActionInProgress(getState())) {
    return Promise.reject(new Error('Reschedule, accept or decline already in progress'));
  }
  dispatch(rescheduleSaleRequest());

  const { bookingData, ...rest } = params;
  const bodyParams = {
    id,
    transition: TRANSITION_RESCHEDULE,
    params: rest,
  };
  const queryParams = {
    include: ['booking', 'provider'],
    expand: true,
  };

  const { listingId, exceptionId } = getState().TransactionPage;

  return transitionPrivileged({ isSpeculative: false, bookingData, bodyParams, queryParams })
    .then(response => {
      dispatch(fetchTimeSlots(listingId));
      dispatch(addMarketplaceEntities(response));
      dispatch(rescheduleSaleSuccess());
      dispatch(fetchCurrentUserNotifications());
      return response;
    })
    .catch(e => {
      dispatch(rescheduleSaleError(storableError(e)));
      log.error(e, 'reschedule-sale-failed', {
        txId: id,
        transition: TRANSITION_RESCHEDULE,
      });
      throw e;
    });
};

export const extendRescheduleSale = (id, params) => async (dispatch, getState, sdk) => {
  if (someActionInProgress(getState())) {
    return Promise.reject(new Error('Reschedule, accept or decline already in progress'));
  }
  dispatch(rescheduleSaleRequest());

  const { bookingData, ...rest } = params;
  let nextTransition = null;
  let prevTransactionId = null;
  try {
    const exTxRes = await sdk.transactions.show({
      id,
    });
    const [exTx] = denormalisedResponseEntities(exTxRes);
    const lastTransition = get(exTx, 'attributes.lastTransition', '');
    prevTransactionId = get(exTx, 'attributes.protectedData.prevTransactionId', null);
    if (lastTransition === TRANSITION_EXTEND_REQUEST_PAYMENT) {
      nextTransition = TRANSITION_EXTEND_RESCHEDULE;
    } else if (lastTransition === TRANSITION_EXTEND_REQUEST_PAYMENT_FREE) {
      nextTransition = TRANSITION_EXTEND_FREE_RESCHEDULE;
    }
  } catch (e) {
    dispatch(rescheduleSaleError(storableError(e)));
    log.error(e, 'reschedule-sale-failed', {
      txId: id,
      transition: nextTransition,
    });
  }
  const bodyParams = {
    id,
    transition: nextTransition,
    params: {
      prevTransactionId,
      ...rest,
    },
  };
  const queryParams = {
    include: ['booking', 'provider'],
    expand: true,
  };

  const { listingId } = getState().TransactionPage;

  return extendTransitionPrivileged({ isSpeculative: false, bookingData, bodyParams, queryParams })
    .then(response => {
      dispatch(fetchTimeSlots(listingId));
      dispatch(addMarketplaceEntities(response));
      dispatch(rescheduleSaleSuccess());
      dispatch(fetchCurrentUserNotifications());
      return response;
    })
    .catch(e => {
      dispatch(rescheduleSaleError(storableError(e)));
      log.error(e, 'reschedule-sale-failed', {
        txId: id,
        transition: nextTransition,
      });
      throw e;
    });
}

export const acceptSale = id => (dispatch, getState, sdk) => {
  if (someActionInProgress(getState())) {
    return Promise.reject(new Error('Reschedule, accept or decline already in progress'));
  }
  dispatch(acceptSaleRequest());

  return sdk.transactions
    .transition({ id, transition: TRANSITION_ACCEPT, params: {} }, { expand: true })
    .then(response => {
      dispatch(addMarketplaceEntities(response));
      dispatch(acceptSaleSuccess());
      dispatch(fetchCurrentUserNotifications());
      return response;
    })
    .catch(e => {
      dispatch(acceptSaleError(storableError(e)));
      log.error(e, 'accept-sale-failed', {
        txId: id,
        transition: TRANSITION_ACCEPT,
      });
      throw e;
    });
};

export const declineSale = id => (dispatch, getState, sdk) => {
  if (someActionInProgress(getState())) {
    return Promise.reject(new Error('Reschedule, accept or decline already in progress'));
  }
  dispatch(declineSaleRequest());

  return sdk.transactions
    .transition({ id, transition: TRANSITION_DECLINE, params: {} }, { expand: true })
    .then(response => {
      dispatch(addMarketplaceEntities(response));
      dispatch(declineSaleSuccess());
      dispatch(fetchCurrentUserNotifications());
      return response;
    })
    .catch(e => {
      dispatch(declineSaleError(storableError(e)));
      log.error(e, 'reject-sale-failed', {
        txId: id,
        transition: TRANSITION_DECLINE,
      });
      throw e;
    });
};

const fetchMessages = (txId, page) => (dispatch, getState, sdk) => {
  const paging = { page, per_page: MESSAGES_PAGE_SIZE };
  dispatch(fetchMessagesRequest());

  return sdk.messages
    .query({
      transaction_id: txId,
      include: ['sender', 'sender.profileImage'],
      ...IMAGE_VARIANTS,
      ...paging,
    })
    .then(response => {
      const messages = denormalisedResponseEntities(response);
      const { totalItems, totalPages, page: fetchedPage } = response.data.meta;
      const pagination = { totalItems, totalPages, page: fetchedPage };
      const totalMessages = getState().TransactionPage.totalMessages;

      // Original fetchMessages call succeeded
      dispatch(fetchMessagesSuccess(messages, pagination));

      // Check if totalItems has changed between fetched pagination pages
      // if totalItems has changed, fetch first page again to include new incoming messages.
      // TODO if there're more than 100 incoming messages,
      // this should loop through most recent pages instead of fetching just the first one.
      if (totalItems > totalMessages && page > 1) {
        dispatch(fetchMessages(txId, 1))
          .then(() => {
            // Original fetch was enough as a response for user action,
            // this just includes new incoming messages
          })
          .catch(() => {
            // Background update, no need to to do anything atm.
          });
      }
    })
    .catch(e => {
      dispatch(fetchMessagesError(storableError(e)));
      throw e;
    });
};

export const fetchMoreMessages = txId => (dispatch, getState, sdk) => {
  const state = getState();
  const { oldestMessagePageFetched, totalMessagePages } = state.TransactionPage;
  const hasMoreOldMessages = totalMessagePages > oldestMessagePageFetched;

  // In case there're no more old pages left we default to fetching the current cursor position
  const nextPage = hasMoreOldMessages ? oldestMessagePageFetched + 1 : oldestMessagePageFetched;

  return dispatch(fetchMessages(txId, nextPage));
};

const saveLastMessageCreatedAt = transactionId => {
  return saveLastMessageAt({ transactionId })
    .then(() => {
      //do nothing
    })
    .catch(err => {
      log.error(err, 'save-last-message-created-at');
    });
};

export const sendMessage = (txId, message) => (dispatch, getState, sdk) => {
  dispatch(sendMessageRequest());

  return sdk.messages
    .send({ transactionId: txId, content: message })
    .then(response => {
      saveLastMessageCreatedAt(txId.uuid);
      const messageId = response.data.data.id;

      // We fetch the first page again to add sent message to the page data
      // and update possible incoming messages too.
      // TODO if there're more than 100 incoming messages,
      // this should loop through most recent pages instead of fetching just the first one.
      return dispatch(fetchMessages(txId, 1))
        .then(() => {
          dispatch(sendMessageSuccess());
          return messageId;
        })
        .catch(() => dispatch(sendMessageSuccess()));
    })
    .catch(e => {
      dispatch(sendMessageError(storableError(e)));
      // Rethrow so the page can track whether the sending failed, and
      // keep the message in the form for a retry.
      throw e;
    });
};

const REVIEW_TX_INCLUDES = ['reviews', 'reviews.author', 'reviews.subject'];
const IMAGE_VARIANTS = {
  'fields.image': [
    // Profile images
    'variants.square-small',
    'variants.square-small2x',

    // Listing images:
    'variants.landscape-crop',
    'variants.landscape-crop2x',
  ],
};

// If other party has already sent a review, we need to make transition to
// TRANSITION_REVIEW_2_BY_<CUSTOMER/PROVIDER>
const sendReviewAsSecond = (tx, params, role, dispatch, sdk) => {
  const transition = getReview2Transition(role === CUSTOMER, tx);
  const include = REVIEW_TX_INCLUDES;

  return sdk.transactions
    .transition({
      id: new UUID(tx?.id.uuid),
      transition,
      params
    }, { expand: true, include, ...IMAGE_VARIANTS })
    .then(response => {
      dispatch(addMarketplaceEntities(response));
      dispatch(sendReviewSuccess());
      return response;
    })
    .catch(e => {
      console.log(e);
      dispatch(sendReviewError(storableError(e)));

      // Rethrow so the page can track whether the sending failed, and
      // keep the message in the form for a retry.
      throw e;
    });
};

// If other party has not yet sent a review, we need to make transition to
// TRANSITION_REVIEW_1_BY_<CUSTOMER/PROVIDER>
// However, the other party might have made the review after previous data synch point.
// So, error is likely to happen and then we must try another state transition
// by calling sendReviewAsSecond().
const sendReviewAsFirst = (tx, params, role, dispatch, sdk) => {
  const transition = getReview1Transition(role === CUSTOMER, tx);
  const include = REVIEW_TX_INCLUDES;

  return sdk.transactions
    .transition({ id: tx.id, transition, params }, { expand: true, include, ...IMAGE_VARIANTS })
    .then(response => {
      dispatch(addMarketplaceEntities(response));
      dispatch(sendReviewSuccess());
      return response;
    })
    .catch(e => {
      // If transaction transition is invalid, lets try another endpoint.
      if (isTransactionsTransitionInvalidTransition(e)) {
        return sendReviewAsSecond(tx.id, params, role, dispatch, sdk);
      } else {
        dispatch(sendReviewError(storableError(e)));

        // Rethrow so the page can track whether the sending failed, and
        // keep the message in the form for a retry.
        throw e;
      }
    });
};

export const sendReview = (role, tx, reviewRating, reviewContent) => (dispatch, getState, sdk) => {
  const params = { reviewRating, reviewContent };

  const txStateOtherPartyFirst = txIsInFirstReviewBy(tx, role !== CUSTOMER);

  dispatch(sendReviewRequest());

  return txStateOtherPartyFirst
    ? sendReviewAsSecond(tx, params, role, dispatch, sdk)
    : sendReviewAsFirst(tx, params, role, dispatch, sdk);
};

const isNonEmpty = value => {
  return typeof value === 'object' || Array.isArray(value) ? !isEmpty(value) : !!value;
};

export const timeSlotsRequest = params => (dispatch, getState, sdk) => {
  const maxTimeSlots = 90;
  const { listingId, start, end } = params;
  const allQueryParams = [];
  let startDate = start;
  let endDate = end;

  if (daysBetween(startDate, endDate) > 90) {
    while (daysBetween(startDate, endDate) > 90) {
      const newEndDate = moment(startDate)
        .utc()
        .startOf('day')
        .add(maxTimeSlots, 'days')
        .toDate();

      allQueryParams.push({
        listingId,
        start: startDate,
        end: newEndDate
      });
      startDate = newEndDate;
    }

    allQueryParams.push({ listingId, start: startDate, end: endDate });
  }
  if (allQueryParams.length) {
    const listTask = allQueryParams.map(param => sdk.timeslots.query(param));
    return Promise.all(listTask).then(responses => {
      const allTimeSlots = responses.reduce((result, item) => {
        const denormalisedItem = denormalisedResponseEntities(item);
        const newResult = result.concat(denormalisedItem);
        return newResult;
      }, []);

      return allTimeSlots;
    })
  }

  return sdk.timeslots.query(params).then(response => {
    return denormalisedResponseEntities(response);
  });
};

const fetchTimeSlots = listingId => (dispatch, getState, sdk) => {
  dispatch(fetchTimeSlotsRequest);

  // Time slots can be fetched for 90 days at a time,
  // for at most 180 days from now. If max number of bookable
  // day exceeds 90, a second request is made.

  const maxTimeSlots = 90;
  // booking range: today + bookable days -1
  const bookingRange = config.dayCountAvailableForFetching - 1;
  const timeSlotsRange = Math.min(bookingRange, maxTimeSlots);

  const start = moment
    .utc()
    .startOf('day')
    .toDate();
  const end = moment()
    .utc()
    .startOf('day')
    .add(timeSlotsRange, 'days')
    .toDate();
  const params = { listingId, start, end };

  return dispatch(timeSlotsRequest(params))
    .then(timeSlots => {
      const secondRequest = bookingRange > maxTimeSlots;

      if (secondRequest) {
        const secondRange = Math.min(maxTimeSlots, bookingRange - maxTimeSlots);
        const secondEnd = moment(end)
          .utc()
          .startOf('day')
          .add(secondRange, 'days')
          .toDate();
        const secondParams = {
          listingId,
          start: end,
          end: secondEnd,
        };

        return dispatch(timeSlotsRequest(secondParams)).then(secondBatch => {
          const secondCombined = timeSlots.concat(secondBatch);
          const thirdRequest = bookingRange > maxTimeSlots + secondRange;

          if (thirdRequest) {
            const thirdRange = Math.min(maxTimeSlots, bookingRange - maxTimeSlots - secondRange);
            const thirdEnd = moment(secondEnd)
              .utc()
              .startOf('day')
              .add(thirdRange, 'days')
              .toDate();
            const thirdParams = {
              listingId,
              start: secondEnd,
              end: thirdEnd,
            };

            return dispatch(timeSlotsRequest(thirdParams)).then(thirdBatch => {
              const thirdCombined = secondCombined.concat(thirdBatch);
              const fourthRequest = bookingRange > maxTimeSlots + secondRange + thirdRange;

              if (fourthRequest) {
                const fourthRange = Math.min(
                  maxTimeSlots,
                  bookingRange - maxTimeSlots - secondRange - thirdRange
                );
                const fourthEnd = moment(thirdEnd)
                  .utc()
                  .startOf('day')
                  .add(fourthRange, 'days')
                  .toDate();
                const fourthParams = {
                  listingId,
                  start: thirdEnd,
                  end: fourthEnd,
                };

                return dispatch(timeSlotsRequest(fourthParams)).then(fourthBatch => {
                  const fourthCombined = thirdCombined.concat(fourthBatch);
                  dispatch(fetchTimeSlotsSuccess(fourthCombined));
                });
              }
            });
          }
        });
      } else {
        dispatch(fetchTimeSlotsSuccess(timeSlots));
      }
    })
    .catch(e => {
      dispatch(fetchTimeSlotsError(storableError(e)));
    });
};

export const fetchNextTransitions = id => (dispatch, getState, sdk) => {
  dispatch(fetchTransitionsRequest());

  return sdk.processTransitions
    .query({ transactionId: id })
    .then(res => {
      dispatch(fetchTransitionsSuccess(res.data.data));
    })
    .catch(e => {
      dispatch(fetchTransitionsError(storableError(e)));
    });
};

export const fetchTransactionLineItems = ({ bookingData, listingId, isOwnListing }) => dispatch => {
  dispatch(fetchLineItemsRequest());
  return transactionLineItems({ bookingData, listingId, isOwnListing })
    .then(response => {
      const lineItems = response.data;
      dispatch(fetchLineItemsSuccess(lineItems));
    })
    .catch(e => {
      dispatch(fetchLineItemsError(storableError(e)));
      log.error(e, 'fetching-line-items-failed', {
        listingId: listingId.uuid,
        bookingData: bookingData,
      });
    });
};

export const fetchExtendTransactionLineItem = ({
  bookingData,
  listingId,
  isOwnListing,
}) => dispatch => {
  dispatch(fetchLineItemsRequest());
  extendTransactionLineItems({ bookingData, listingId, isOwnListing })
    .then(response => {
      const lineItems = response.data;
      dispatch(fetchLineItemsSuccess(lineItems));
    })
    .catch(e => {
      dispatch(fetchLineItemsError(storableError(e)));
      log.error(e, 'fetching-line-items-failed', {
        listingId: listingId.uuid,
        bookingData: bookingData,
      });
    });
};

export const fetchReofferTransactionLineItem = ({
  bookingData,
  listingId,
  isOwnListing,
}) => dispatch => {
  dispatch(fetchLineItemsRequest());
  reofferTransactionLineItems({ bookingData, listingId, isOwnListing })
    .then(response => {
      const lineItems = response.data;
      dispatch(fetchLineItemsSuccess(lineItems));
    })
    .catch(e => {
      dispatch(fetchLineItemsError(storableError(e)));
      log.error(e, 'fetching-line-items-failed', {
        listingId: listingId.uuid,
        bookingData: bookingData,
      });
    });
};

export const createHoldingSlotTx = ({ txId, params }) => async (dispatch) => {
  dispatch(createHoldingSlotTxRequest());
  try {
    const response = await createHoldingSlotTransaction({
      mainTransactionId: txId,
      params,
    });
    const [holdingSlotTx] = denormalisedResponseEntities(response);
    dispatch(createHoldingSlotTxSuccess());
    return holdingSlotTx.id.uuid;
  } catch (error) {
    dispatch(createHoldingSlotTxFail(storableError(error)));
    log.error(error, 'create-holding-slot-transaction', {
      txId: txId,
    });
    throw error;
  }
}

export const declineHoldingSlotTx = (txId) => async (dispatch) => {
  dispatch(declineHoldingSlotTxRequest());
  try {
    await declineHoldingSlotTransaction({ txId });
    dispatch(declineHoldingSlotTxSuccess());
  } catch (error) {
    dispatch(declineHoldingSlotTxFail(storableError(error)));
    log.error(error, 'decline-holding-slot-transaction', {
      txId: txId,
    });
  }
}
export const waitForAutoTransitionStartReviewFinish = txId => async (dispatch, getState, sdk) => {
  try {
    dispatch(waitAutoTransitionStartReviewRequest());
    // wait 5s for tx to finish auto transition start review finishes
    await new Promise(resolve => setTimeout(resolve, 5000));
    const response = await sdk.transactions.show({ id: txId }, { expand: true });
    dispatch(addMarketplaceEntities(response));
    dispatch(fetchCurrentUserNotifications());
    dispatch(waitAutoTransitionStartReviewSuccess());
  } catch (e) {
    dispatch(waitAutoTransitionStartReviewError(storableError(e)));
  }
};

export const transit = (id, transition, params = {}) => (dispatch, getState, sdk) => {
  if (transitInProgress(getState())) {
    return Promise.reject(new Error('A pending transit already in progress'));
  }
  dispatch(transitRequest());

  const isPrivilegedTransition = isPrivileged(transition) || isExtendPrivileged(transition);

  const bodyParams = { id, transition, params };
  const queryParams = {
    include: ['booking', 'provider'],
    expand: true,
  };

  if (isPrivilegedTransition) {
    return actionPrivileged({ bodyParams, queryParams })
      .then(response => {
        dispatch(addMarketplaceEntities(response));
        dispatch(transitSuccess());
        dispatch(fetchCurrentUserNotifications());
        return response;
      })
      .catch(e => {
        dispatch(transitError(storableError(e)));
        log.error(e, 'transit-failed', {
          txId: id,
          transition: transition,
        });
        throw e;
      });
  }

  return sdk.transactions
    .transition({ id, transition: transition, params: params }, { expand: true })
    .then(response => {
      dispatch(addMarketplaceEntities(response));
      dispatch(transitSuccess());
      dispatch(fetchCurrentUserNotifications());
      return response;
    })
    .catch(e => {
      dispatch(transitError(storableError(e)));
      log.error(e, 'transit-failed', {
        txId: id,
        transition: transition,
      });
      throw e;
    });
};

export const retryPayment = ({ transactionId }) => dispatch => {
  dispatch(retryPaymentRequest());
  apiRetryPayment({ transactionId })
    .then(response => {
      dispatch(retryPaymentSuccess());
      const txId = new UUID(transactionId);
      return Promise.all([
        dispatch(fetchTransaction(txId, 'customer')),
        dispatch(fetchMessages(txId, 1)),
        dispatch(fetchNextTransitions(txId)),
      ]);
    })
    .catch(error => {
      console.error(error);
      dispatch(retryPaymentError(storableError(error)));
    });
};

export const renewBond = ({ transactionId }) => dispatch => {
  dispatch(renewBondRequest());
  apiRenewBond({ transactionId })
    .then(response => {
      dispatch(renewBondSuccess());
      const txId = new UUID(transactionId);
      return Promise.all([
        dispatch(fetchTransaction(txId, 'customer')),
        dispatch(fetchMessages(txId, 1)),
        dispatch(fetchNextTransitions(txId)),
      ]);
    })
    .catch(error => {
      console.error(error);
      dispatch(renewBondError(storableError(error)));
    });
};

export const changeAvailabilityExceptionCurrentBooking = (transactionId, type) => (
  dispatch,
  getState
) => {
  const handleError = e => {
    log.error(e, 'change-availability-failed', {
      transactionId,
      type,
    });
  };

  const { listingId, exceptionId } = getState().TransactionPage;

  if (listingId && transactionId) {
    if (type === ACTION_ADD_AVAILABILITY_EXCEPTIONS) {
      return addAvailabilityExceptionCurrentBooking({ transactionId })
        .then(response => {
          const exceptionResId = get(response, 'id.uuid', null);
          const message = get(response, 'message', null);

          if (message) {
            throw new Error(message);
          }

          dispatch(addAvailabilityExceptionSuccess(exceptionResId));
          dispatch(fetchTimeSlots(listingId));
        })
        .catch(handleError);
    } else if (type === ACTION_REMOVE_AVAILABILITY_EXCEPTIONS) {
      return removeAvailabilityExceptionCurrentBooking({ transactionId, exceptionId })
        .then(response => {
          const exceptionResId = get(response, 'id.uuid', null);

          if (!isEqual(exceptionResId, exceptionId)) {
            throw new Error(
              `Exception is not matched: current ${exceptionId} vs ${exceptionResId}`
            );
          }

          dispatch(removeAvailabilityExceptionSuccess());
          dispatch(fetchTimeSlots(listingId));
        })
        .catch(handleError);
    }
  }
};

// loadData is a collection of async calls that need to be made
// before page has all the info it needs to render itself
export const loadData = params => (dispatch, getState) => {
  const txId = new UUID(params.id);
  const state = getState().TransactionPage;
  const txRef = state.transactionRef;
  const txRole = params.transactionRole;

  // In case a transaction reference is found from a previous
  // data load -> clear the state. Otherwise keep the non-null
  // and non-empty values which may have been set from a previous page.
  const initialValues = txRef ? {} : pickBy(state, isNonEmpty);
  dispatch(setInitialValues(initialValues));

  // Sale / order (i.e. transaction entity in API)
  return Promise.all([
    dispatch(fetchTransaction(txId, txRole)),
    dispatch(fetchMessages(txId, 1)),
    dispatch(fetchNextTransitions(txId)),
  ]);
};
